import * as types from './checklistItem.types';
import * as constants from './checklistItem.constants';
import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

export const storeChecklistItem = generateStoreResourceAction<types.IChecklistItem>(constants.STORE_CHECKLISTITEM);
export const clearChecklistItem = generateClearResourceAction(constants.CLEAR_CHECKLISTITEM);
